import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../../utils/api";

// Busqueda de plantillas
export const findFormList = createAsyncThunk(
    "profileFormAssigned/findFormList",
    async (arg, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("token");
            const headers = new Headers();
            headers.append("Authorization", `Bearer ${token}`);
            headers.append("Content-Type", "application/json");
      
            const result = await fetch(`${api.baseURL}form?select=id,name&where={"assignedTo":""}&limit=100&sort=name%20ASC`,{
                method: "GET",
                headers: headers,
            });
            const data = await result.json();
            return data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
